// src/Routes/DefaultRedirect.tsx
// Điều hướng tới trang mặc định sau khi vào "/" hoặc gõ 1 URL không khớp route nào — thay vì trỏ
// cứng "/dashboard" (nhiều role không có quyền xem Dashboard, vào app là gặp 403 ngay). Giờ trỏ tới
// trang ĐẦU TIÊN mà quyền của role hiện tại được phép xem, theo đúng thứ tự hiển thị trong menu
// (state.Permission.firstAllowedPath — tính ở slices/permission/thunk.ts#findFirstMenuUrl).
// Luôn được render bên trong <AuthProtected>, nên tại đây permission chắc chắn đã loaded === true.

import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "../slices";

const DefaultRedirect = () => {
  const firstAllowedPath = useSelector(
    (state: RootState) => state.Permission.firstAllowedPath,
  );

  // Role không có quyền xem bất kỳ trang nào (hoặc tải menu thất bại) — về access-denied thay vì
  // vẫn cố trỏ "/dashboard" và lặp lại đúng lỗi 403 đang cần sửa.
  return <Navigate to={firstAllowedPath || "/access-denied"} replace />;
};

export default DefaultRedirect;
